import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';
import { noop } from 'Helpers/PropTypes';
import {
  EditMessageActionBar,
} from 'Components/ComponentLibrary/Components/Uncategorized/EditMessageInput/components/EditMessageActionBar';
import {
  DEFAULT_INPUT_MIN_HEIGHT_FOR_MESSAGE_EDIT,
} from 'Components/ComponentLibrary/Components/Uncategorized/EditMessageInput/EditMessageInput';

const useStyles = buildUseStyles('MemberEditMessageInput', (theme) => ({
  root: {
    paddingTop: theme.spacing(1),
  },
  bottomToolbar: {
    marginTop: theme.spacing(1),
  },
  hidden: {
    display: 'none',
  },
}));

const MemberEditMessageInput = ({
  className,
  handleSubmit,
  handleChange,
  value,
  onClose,
  rounded,
  customConfig,
  inputMinHeight,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box className={classNames(className, classes.root)}>
      <RichTextField
        inputMinHeight={inputMinHeight}
        onChange={handleChange}
        value={value}
        placeholder={'Edit message here...'}
        rounded={rounded}
        customConfig={customConfig}
      />
      <EditMessageActionBar
        className={classes.bottomToolbar}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Box>
  );
};

MemberEditMessageInput.defaultProps = {
  className: '',
  handleChange: noop,
  handleSubmit: noop,
  onClose: noop,
  value: '',
  rounded: false,
  inputMinHeight: DEFAULT_INPUT_MIN_HEIGHT_FOR_MESSAGE_EDIT,
  customConfig: {},
};

MemberEditMessageInput.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.string,
  rounded: PropTypes.bool,
  customConfig: PropTypes.object,
  inputMinHeight: PropTypes.number,
};

export { MemberEditMessageInput };
